export const CHANGE_VM = 'CHANGE_VM';